import { render } from "./index.vue?vue&type=template&id=f92a989a&scoped=true&bindings={}"
import script from "./async-component.js?vue&type=script&lang=js"
export * from "./async-component.js?vue&type=script&lang=js"

import "./async-component.scss?vue&type=style&index=0&id=f92a989a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-f92a989a"

export default script